
        var result = require("!!../../../../node_modules/css-loader/index.js!./results.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/contract.awards/results.component.css
// module id = 1512
// module chunks = 0